module.exports = __webpack_public_path__ + "static/media/step-6.0ca4fd92.png";